import React, { SyntheticEvent } from 'react';
import Tooltip from '@creditflowresearch/uilib/Tooltip';
import Button from '@creditflowresearch/uilib/Button';
import IconExpandArrows from '@creditflowresearch/uilib/Icon/IconExpandArrows';
import IconCollapseArrows from '@creditflowresearch/uilib/Icon/IconCollapseArrows';

interface IExpandCollapseButtonProps {
  onClick: (e: SyntheticEvent) => void,
  dataTest?: string,
  disabled?: boolean,
  className?: string,
}

const ExpandCollapseButton = ({
  title,
  icon,
  onClick,
  dataTest,
  disabled,
  className,
}: IExpandCollapseButtonProps & { title?: React.ReactNode, icon?: React.ReactNode }) => (
  <Tooltip content={ title } containerClassName={ className }>
    <Button
      variant="outline"
      size="S"
      icon={ icon }
      onClick={ onClick }
      dataTest={ dataTest }
      disabled={ disabled }
    />
  </Tooltip>
);

export const ExpandAllButton = ({ onClick, dataTest = 'expandAllDeals', disabled, className }: IExpandCollapseButtonProps) => (
  <ExpandCollapseButton
    title="Expand all"
    icon={ <IconExpandArrows /> }
    onClick={ onClick }
    dataTest={ dataTest }
    disabled={ disabled }
    className={ className }
  />
);

export const CollapseAllButton = ({ onClick, dataTest = 'collapseAllDeals', disabled, className }: IExpandCollapseButtonProps) => (
  <ExpandCollapseButton
    title="Collapse all"
    icon={ <IconCollapseArrows /> }
    onClick={ onClick }
    dataTest={ dataTest }
    disabled={ disabled }
    className={ className }
  />
);
